import { getBase64Content, getBase64Type } from './getBase64Info';
import b64toBlob from 'b64-to-blob';

const heicConvert = require('heic-convert');

export const heicToBase64 = async (url: any) => {
  try {
    console.log('trigger heic to image');
    const output = await fetch(url).then(async (data) => {
      const buffer = Buffer.from(await data.arrayBuffer());
      return heicConvert({ buffer, format: 'PNG' });
    });

    const imgBase64 =
      typeof window !== 'undefined' &&
      btoa(
        output.reduce(
          (data: any, byte: any) => `${data}${String.fromCharCode(byte)}`,
          ''
        )
      );

    return `data:image/png;base64,${imgBase64}`;
  } catch (err) {
    console.log('CANNOT CONVERT SINCE THIS IS CONVERTED JPEG');
    return url;
  }
};

export const base64ToBlob = (dataUrl: string) => {
  const imageType = getBase64Type(dataUrl) || '';
  const imageBase64Value = getBase64Content(dataUrl) || '';
  return b64toBlob(imageBase64Value, imageType);
};
